import React from "react";
import SearchIcon from "icons/search-normal.svg";
import cx from "classnames";

type Props = {
  placeholder?: string;
  value: string;
  setValue?: (value: string) => void;
  handleSearch?: (value?: string) => Promise<void>;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Search: React.FC<Props> = ({
  placeholder,
  value,
  setValue,
  handleSearch,
  className,
  onChange,
}): JSX.Element => {
  const handleClick = () => {
    if (value.length > 0) {
      handleSearch && handleSearch(value);
    } else {
      handleClear();
    }
  };
  const handleClear = () => {
    setValue && setValue("");
    handleSearch && handleSearch("");
  };

  return (
    <div
      className={cx(
        "relative flex bg-bt-white pl-4 rounded-full w-full my-auto h-14",
        className
      )}
      style={{
        // padding: "16px 200px 16px 16px",
        borderRadius: "60px",
        // height: "54px",
      }}
    >
      <div className="flex flex-row">
        <img src={SearchIcon} alt="icon" width={24} height={24} />
      </div>
      <input
        name="search"
        type="text"
        placeholder={placeholder || `Search`}
        className="w-full font-nunito border-transparent focus:border-transparent focus:ring-0 rounded-full"
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch && handleClick();
          }
        }}
        value={value}
        style={{
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: "16px",
          lineHeight: "22px",
          color: "#8E8E8E",
        }}
      />
    </div>
  );
};

export default Search;
